import { DecorationEntryDto } from './decoration-entry-dto';
import { LabelDto } from './label-dto';

export class LabelEntryDto extends DecorationEntryDto  {
    isAdhesiveUsed: boolean | null = null;
    removabilityConditionId = -1;
    underlyingComponent!: LabelDto;
}
